import { useState } from 'react';

import { ApiError } from '../api/client';
import { Banner } from '../components/ui';
import { useAuth } from '../hooks/useAuth';

export default function Login() {
  const { signIn } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await signIn(email, password);
    } catch (cause) {
      setError(cause instanceof ApiError ? cause.detail : 'Connexion impossible.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="login">
      <h1>Planning des équipes</h1>
      <p className="muted">Connectez-vous pour continuer.</p>
      <form className="card stack" onSubmit={submit}>
        {error && <Banner kind="error">{error}</Banner>}
        <div>
          <label htmlFor="email">Adresse e-mail</label>
          <input
            id="email"
            type="email"
            autoComplete="username"
            required
            style={{ width: '100%' }}
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </div>
        <div>
          <label htmlFor="password">Mot de passe</label>
          <input
            id="password"
            type="password"
            autoComplete="current-password"
            required
            style={{ width: '100%' }}
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
        </div>
        <button className="primary" type="submit" disabled={busy}>
          {busy ? 'Connexion…' : 'Se connecter'}
        </button>
      </form>
    </main>
  );
}
